import { ObjectSchema, array, mixed, object, string } from 'yup';
import { useMemo } from 'react';
import { SetupUserFormState } from '@Forms/users/SetupUserFormContext';

export const useSetupUserUseCaseSchema = (): ObjectSchema<Partial<SetupUserFormState>> => {
  return useMemo(
    () =>
      object<SetupUserFormState>().shape({
        isProviderUsersAdmin: string().required('is provider users admin is required field'),
        allowedRoleIds: array().when('isProviderUsersAdmin', {
          is: 'true',
          then: (schema) => schema.required('allowed role ids is required field'),
          otherwise: (schema) => schema.notRequired(),
        }),
        email: string().email().required('email is required field'),
        password: string()
          .optional()
          .transform((value) => (value === '' || value === undefined ? undefined : value))
          .test(
            'password-policy-if-set',
            'Password must meet complexity rules when provided',
            function (value) {
              if (!value) return true;
              if (/\s/.test(value)) return false;
              if (value.length < 8) return false;
              if (!/[a-z]/.test(value)) return false;
              if (!/[A-Z]/.test(value)) return false;
              if (!/[0-9]/.test(value)) return false;
              if (!/[^a-zA-Z0-9]/.test(value)) return false;
              const email = this.parent.email as string | undefined;
              if (!email) return true;
              const trimmedPassword = value.replace(/\s/g, '').toLowerCase();
              const trimmedEmail = email.replace(/\s/g, '').toLowerCase();
              return !trimmedPassword.includes(trimmedEmail);
            }
          ),
        roleIds: mixed<string | string[]>()
          .test('is-string-or-array', 'roleIds must be a string or an array', (value) => {
            return typeof value === 'string' || Array.isArray(value);
          })
          .required('roleId is required field'),
        providerRgs: array()
          .of(
            object({
              rgsId: string().required('RGS ID is required'),
              providerIds: array()
                .of(string().required('Each provider ID must be a string'))
                .min(1, 'At least one provider ID is required')
                .required('Provider IDs are required'),
            })
          )
          .min(1, 'At least one RGS entry is required')
          .required('Provider RGS is required field'),
      }),
    []
  );
};
